import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-fans-details',
  templateUrl: './fans-details.component.html',
  styleUrls: ['./fans-details.component.css']
})
export class FansDetailsComponent implements OnInit {
  searchText: string;
  id: number;
  countryData: any = {};
  countryData1: any = {};
  currentUser: any;
  status: boolean;
  followed: boolean;
  fans = [];
  isLoaderVisible = false;
  items = [];
  fansname :any;
  fanscount: any;
  pageOfItems: Array<any>;
  pageSize = 12;
  maxPages = 12;
  initialPage = 1;
  name:string;
  //countery:any;
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);

    this.countryDetails();
    
  }
  countryDetails() {
    this.isLoaderVisible = true;
    const data = {
      id: this.id
    };
      this.iffhsService.getCountryDetails(data).pipe(first<any>()).subscribe(
        dataget => 
        { 
          this.countryData = dataget[0];
          const data = {
            countryName: this.countryData.name,
          };
          this.iffhsService.getFansnew(data).pipe(first<any[]>()).subscribe(Fansnames => this.fansname = Fansnames);
          this.iffhsService.getFanscount(data).pipe(first<any[]>()).subscribe(Fanscounts => this.fanscount = Fanscounts);
        });
    this.isLoaderVisible = false;
  }
  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }
  getFans() {
    this.isLoaderVisible = true;
    
    this.isLoaderVisible = false;
  }
}
